import { common } from "./common";
import { error } from "./error";
import { enums } from "./enums";
import { user } from "./user";
import { plan } from "./plan";
import { technical } from "./technical";
import { form } from "./form";
import { question } from "./question";
import { method } from "./method";
import { evaluation } from "./evaluation";
import { analysis } from "./analysis";
import { employee } from "./employee";
import { date } from "./date";
import { report } from "./report";
import { equipment } from "./equipment";
import { options } from "./options";
import { result } from "./result";
import { checkout } from "./checkout";

export const language = {
  translations: {
    common,
    checkout,
    equipment,
    enums,
    error,
    user,
    plan,
    technical,
    form,
    question,
    method,
    evaluation,
    analysis,
    employee,
    date,
    options,
    report,
    result,
  },
};
